import { http } from '@/utils'
// 人员信息详情
export const personnelDetails = (id?: any): any =>
  http.get(`/hrm/employee/${id}`, { params: { id } })
